import React, { Component } from 'react';
import axios from 'axios';
import API from '../../API';
import LocationModal from './location-modal';
import './location-section.css';

class LocationSection extends Component {
  constructor(props) {
    super(props);
    this.state = {
      address_list: [],
      showAddAddressModal: false,
      selectedAddressId: null
    };
    this.getAddress = this.getAddress.bind(this);
  }

  componentDidMount() {
    this.getAddress();
  }

  getAddress() {
    axios.get(API.baseURL + `/get_addresses.json`, API.options)
      .then(response => response.data)
      .then((res) => {
        this.setState({
          address_list: res.data || [],
          showAddAddressModal: false
        });
      })
      .catch(error => {
        console.error("Error fetching addresses:", error);
        this.setState({ address_list: [] });
      });
  }

  toggleModal = () => {
    this.setState(prevState => ({
      showAddAddressModal: !prevState.showAddAddressModal
    }));
  }

  handleAddressSelect = (id) => {
    this.setState({ selectedAddressId: id });
    if (this.props.onAddressSelect) {
      this.props.onAddressSelect(id);
    }
  }

  handleSaveDraft = () => {
    if (this.props.onSaveDraft) {
      this.props.onSaveDraft();
    }
  }

  handlePost = () => {
    if (this.props.onPost) {
      this.props.onPost(this.state.selectedAddressId);
    }
  }

  render() {
    return (
      <div className="location-section-container">
        {/* Privacy message */}
        <div className="card privacy-message">
          <div className="card-body p-3">
            <p className="mb-0">Address will be shared only when you hire a specific provider.</p>
          </div>
        </div>

        {/* Location card */}
        <div className="card location-card">
          <div className="card-body p-4">
            <div className="location-header">
              <h5 className="mb-0">Add your Location</h5>
              <button 
                className="add-button" 
                onClick={this.toggleModal}
                aria-label="Add location"
              >
                <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M13 7H1M7 13V1" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                </svg>
              </button>
            </div>
            
            {this.state.address_list.length > 0 ? (
              <>
                <div className="saved-location-header mt-4">
                  <span>Saved location</span>
                </div>
                <div className="saved-location-list">
                  {this.state.address_list.map((address) => (
                    <div 
                      key={address.id} 
                      className={`location-item ${this.state.selectedAddressId === address.id ? 'selected' : ''}`}
                      onClick={() => this.handleAddressSelect(address.id)}
                    >
                      <div className="location-type">{address.type_of_address}</div>
                      <div className="location-address">
                        {address.street_name}, {address.city}, {address.state}, {address.zip_code}
                      </div>
                      <div className="location-selector">
                        <span className="selector-dot"></span>
                      </div>
                    </div>
                  ))}
                </div>
              </>
            ) : (
              <div className="no-locations mt-4">
                <p>No Saved Address Found. Create a new address</p>
              </div>
            )}
          </div>
        </div>

        {/* Location Modal */}
        {this.state.showAddAddressModal && (
          <LocationModal
            show={this.state.showAddAddressModal}
            onClose={this.toggleModal}
            onSave={this.getAddress}
          />
        )}
      </div>
    );
  }
}

export default LocationSection; 